import { render, staticRenderFns } from "./v-polzunok.vue?vue&type=template&id=53d41b34&"
import script from "./v-polzunok.vue?vue&type=script&lang=js&"
export * from "./v-polzunok.vue?vue&type=script&lang=js&"
import style0 from "./v-polzunok.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports